import { mapActions, mapState } from 'vuex';

/**
 * County setting, Tax Setting tab -> "Disable In Care Of Fields"
 * (taxConfig.disableInCareOfFields).
 *
 * When it is on, that county cannot put text into an In Care Of field anywhere: every entry
 * control binds :readonly to `disableInCareOfFields` (paired with :tabindex so tabbing skips the
 * locked box), and the backend suppresses the automatic/derived writers too (assessor updates,
 * assessor file import, tax roll import, pick list bulk address change).
 *
 * It blocks ENTRY, not display - values already on a record stay visible in the (locked) box
 * and still print on reports.
 *
 * Deliberately NOT gated on isTaxAdminAccessible / isDelinquentTaxAccessible: confirmed by Zach
 * 09/02/2026 that the fields lock for everyone in the county, Tax Users and Tax Admins alike.
 * Do not copy the certificateFieldLocked role-check pattern in GeneralDetailsForm.vue here.
 *
 * Owner Search criteria is intentionally out of scope - it is a search box, and locking it would
 * stop staff finding the records that already carry a value.
 */
export default {
  computed: {
    ...mapState({
      inCareOfTaxSettingItem: (state) => state.SystemConfig.taxSettingItem || {},
    }),
    disableInCareOfFields() {
      return this.inCareOfTaxSettingItem.disableInCareOfFields || false;
    },
  },
  created() {
    // Loaded here rather than relying on a parent so the fields are locked from first paint
    // no matter which screen opened the form.
    this.loadInCareOfTaxConfig({ requiredScope: 'taxConfig' });
  },
  methods: {
    ...mapActions('SystemConfig', {
      loadInCareOfTaxConfig: 'loadConfig',
    }),
  },
};
